<template>
  <a-card :bordered="false">
    <div>
      <div class="operation-wrap" style="display: flex;flex-wrap: wrap">
        <div></div>
        <a-button type="primary" @click="addSysCodingRule">
          {{ $t('ADD') || '添加' }}
        </a-button>
      </div>
      <a-table
        row-key="id"
        :data-source="table.data"
        style="width: 100%">
        <a-table-column
          data-index="code"
          :title="$t('CODE')||'编码'">
        </a-table-column>
        <a-table-column
          data-index="name"
          title="名称">
        </a-table-column>
        <a-table-column
          data-index="review"
          title="预览">
          <template slot-scope="text, record">
            <a-tag
              :key="detail.id"
              :class="detail.type"
              v-for="detail in record.details">
              {{detail.review}}
            </a-tag>
          </template>
        </a-table-column>
        <a-table-column
          data-index="date"
          :title="$t('OPERATION')||'操作'">
          <template slot-scope="text, record">
            <a-button type="link" @click="editSysCodingRule(record.id)">{{ $t('EDIT') || '编辑' }}
            </a-button>
            <a-button type="link" @click="editSysCodingRuleDetail(record.id)">规则
            </a-button>
            <a-button type="link" @click="deleteSysCodingRule(record.id)">{{ $t('REMOVE') || '删除' }}
            </a-button>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal :footer="null"
      title="提示"
      v-model="form.visible">
      <sysCodingRule-edit
        v-if="form.visible"
        :sys-coding-rule-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </sysCodingRule-edit>
    </a-modal>
    <a-modal :footer="null"
      v-model="detailForm.visible"
      @close="getSysCodingRuleList"
      title="编码规则">
      <sys-coding-rule-detail-list
        v-if="detailForm.visible"
        :coding-rule-id="detailForm.data.id">
      </sys-coding-rule-detail-list>
    </a-modal>
  </a-card>
</template>

<script>
import {
  _querySysCodingRules,
  _deleteSysCodingRule,
} from '@/api/sys/sysCodingRuleApi';
import SysCodingRuleEdit from './CodingRuleEdit.vue';
import SysCodingRuleDetailList from './CodingRuleDetailList.vue';

async function getSysCodingRuleList() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const { content, totalElements } = await _querySysCodingRules({
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
  });
  this.table.data = content
    .map(
      x => (
        {
          ...x,
          details: x.details.sort((a, b) => a.sort - b.sort),
        }
      ),
    );
}

function addSysCodingRule() {
  this.form.data.id = null;
  this.form.visible = true;
}

function editSysCodingRule(sysCodingRuleId) {
  this.form.data.id = sysCodingRuleId;
  this.form.visible = true;
}

function editSysCodingRuleDetail(sysCodingRuleId) {
  this.detailForm.data.id = sysCodingRuleId;
  this.detailForm.visible = true;
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getSysCodingRuleList();
}

function closeDetailForm() {
  this.detailForm.data.id = null;
  this.detailForm.visible = false;
  this.getSysCodingRuleList();
}


async function deleteSysCodingRule(sysCodingRuleId) {
  this.$confirm({
    title: this.$t('CONFIRM_REMOVE'),
    content: '',
    onOk: async () => {
      const result = await _deleteSysCodingRule(sysCodingRuleId);
      if (result) {
        this.$message.success(this.$t('REMOVE_SUCCESS'));
        this.getSysCodingRuleList();
      }
    },
  });
}

export default {
  name: 'SysCodingRuleList',
  components: {
    SysCodingRuleDetailList,
    SysCodingRuleEdit
  },
  data() {
    return {
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      detailForm: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        data: [],
        query: {
          page: 1,
          size: 100,
          total: 0,
        },
        sort: {
          prop: 'updateAt',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getSysCodingRuleList,
    deleteSysCodingRule,
    editSysCodingRule,
    addSysCodingRule,
    editSysCodingRuleDetail,
    closeForm,
    closeDetailForm,
  },
  created() {
    this.getSysCodingRuleList();
  },
};
</script>

<style scoped>
  .el-tag.TEXT {
    background-color: #ecf5ff;
    border-color: #d9ecff;
    color: #409eff;
  }

  .el-tag.DATETIME {
    background-color: #f0f9eb;
    border-color: #e1f3d8;
    color: #67c23a;
  }

  .el-tag.AUTO {
    background-color: #fef0f0;
    border-color: #fde2e2;
    color: #f56c6c;
  }
</style>
